export const UPDATE_PREFERRED_UNDERWRITER = "UPDATE_PREFERRED_UNDERWRITER";
export const UPDATE_PREFERRED_UNDERWRITER_NAME =
  "UPDATE_PREFERRED_UNDERWRITER_NAME";
export const UPDATE_SECONDARY_UNDERWRITER = "UPDATE_SECONDARY_UNDERWRITER";
export const UPDATE_UNDERWRITER_ASSISTANT = "UPDATE_UNDERWRITER_ASSISTANT";
export const UPDATE_BROKER = "UPDATE_BROKER";
export const UPDATE_PUNI_BROKER = "UPDATE_PUNI_BROKER";
export const UPDATE_RETAIL_BROKER = "UPDATE_RETAIL_BROKER";
export const UPDATE_SURPLUS_BROKER = "UPDATE_SURPLUS_BROKER";
export const UPDATE_PRODUCER_BROKER = "UPDATE_PRODUCER_BROKER";
export const UPDATE_WHOLESALE_BROKER = "UPDATE_WHOLESALE_BROKER";
export const UPDATE_ASSISTANT = "UPDATE_ASSISTANT";
export const UPDATE_PERSON_BY_TYPE = "UPDATE_PERSON_BY_TYPE";
